import { createCoachInterfaceIntroSteps } from './coachInterfaceIntroSteps';
import type { CoachTourDefinition, TourVariant } from './types';

export const COACH_INTERFACE_INTRO_TOUR: CoachTourDefinition = {
  id: 'coach-interface-intro',
  version: 2,
  titleKey: 'coachInterfaceIntro.title',
  descriptionKey: 'coachInterfaceIntro.description',
  popoverDescriptionKey: 'coachInterfaceIntro.smokeDescription',
  variants: ['desktop', 'mobile'],
  createSteps: createCoachInterfaceIntroSteps,
};

export const COACH_TOURS: readonly CoachTourDefinition[] = [
  COACH_INTERFACE_INTRO_TOUR,
];

export const getCoachTour = (
  tourId: string,
  tours: readonly CoachTourDefinition[] = COACH_TOURS,
): CoachTourDefinition | undefined => (
  tours.find((tour) => tour.id === tourId)
);

export const getTourVariant = (isMobile: boolean): TourVariant => (
  isMobile ? 'mobile' : 'desktop'
);